export enum Periods {
  evidence,
  commit,
  vote,
  appeal,
  execution,
}
